import { useEffect } from 'react';

const useExecuteInlineScript = (containerRef, content) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const currentScript = container.querySelector('script');
    if (!currentScript) return;
    const newScript = document.createElement('script');
    if (currentScript.textContent) {
      newScript.textContent = currentScript.textContent;
    }

    Array.from(currentScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });

    currentScript.parentNode.replaceChild(newScript, currentScript);
  }, [content]);
};

export default useExecuteInlineScript;
